import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "tinyOffset7": "products-33612c4d-tinyOffset7-WXUgJq",
  "tinyOffset2": "products-33612c4d-tinyOffset2-WXUgJq",
  "tinyOffset8": "products-33612c4d-tinyOffset8-WXUgJq",
  "default12": "products-33612c4d-default12-WXUgJq",
  "xwide9": "products-33612c4d-xwide9-WXUgJq",
  "confinedOffset6": "products-33612c4d-confinedOffset6-WXUgJq",
  "wide10": "products-33612c4d-wide10-WXUgJq",
  "wide3": "products-33612c4d-wide3-WXUgJq",
  "wideOffset3": "products-33612c4d-wideOffset3-WXUgJq",
  "confinedOffset2": "products-33612c4d-confinedOffset2-WXUgJq",
  "confined1": "products-33612c4d-confined1-WXUgJq",
  "confinedOffset3": "products-33612c4d-confinedOffset3-WXUgJq",
  "defaultOffset8": "products-33612c4d-defaultOffset8-WXUgJq",
  "tiny4": "products-33612c4d-tiny4-WXUgJq",
  "tinyOffset9": "products-33612c4d-tinyOffset9-WXUgJq",
  "confined6": "products-33612c4d-confined6-WXUgJq",
  "wideOffset10": "products-33612c4d-wideOffset10-WXUgJq",
  "wide4": "products-33612c4d-wide4-WXUgJq",
  "xwide8": "products-33612c4d-xwide8-WXUgJq",
  "xwide10": "products-33612c4d-xwide10-WXUgJq",
  "tinyOffset10": "products-33612c4d-tinyOffset10-WXUgJq",
  "default6": "products-33612c4d-default6-WXUgJq",
  "default3": "products-33612c4d-default3-WXUgJq",
  "tiny5": "products-33612c4d-tiny5-WXUgJq",
  "xwideOffset1": "products-33612c4d-xwideOffset1-WXUgJq",
  "confined3": "products-33612c4d-confined3-WXUgJq",
  "xwideOffset6": "products-33612c4d-xwideOffset6-WXUgJq",
  "xwide3": "products-33612c4d-xwide3-WXUgJq",
  "armstrongGridContainer": "products-33612c4d-armstrongGridContainer-WXUgJq",
  "confined12": "products-33612c4d-confined12-WXUgJq",
  "xwide4": "products-33612c4d-xwide4-WXUgJq",
  "wide5": "products-33612c4d-wide5-WXUgJq",
  "xwideOffset2": "products-33612c4d-xwideOffset2-WXUgJq",
  "wide0": "products-33612c4d-wide0-WXUgJq",
  "confined2": "products-33612c4d-confined2-WXUgJq",
  "tiny0": "products-33612c4d-tiny0-WXUgJq",
  "wideOffset11": "products-33612c4d-wideOffset11-WXUgJq",
  "default0": "products-33612c4d-default0-WXUgJq",
  "confinedOffset0": "products-33612c4d-confinedOffset0-WXUgJq",
  "defaultOffset2": "products-33612c4d-defaultOffset2-WXUgJq",
  "wideGridContainer": "products-33612c4d-wideGridContainer-WXUgJq",
  "tinyOffset0": "products-33612c4d-tinyOffset0-WXUgJq",
  "gridContainer": "products-33612c4d-gridContainer-WXUgJq",
  "confinedOffset7": "products-33612c4d-confinedOffset7-WXUgJq",
  "tiny7": "products-33612c4d-tiny7-WXUgJq",
  "grid": "products-33612c4d-grid-WXUgJq",
  "tiny8": "products-33612c4d-tiny8-WXUgJq",
  "tiny1": "products-33612c4d-tiny1-WXUgJq",
  "confined9": "products-33612c4d-confined9-WXUgJq",
  "xwide7": "products-33612c4d-xwide7-WXUgJq",
  "default4": "products-33612c4d-default4-WXUgJq",
  "tiny3": "products-33612c4d-tiny3-WXUgJq",
  "confined0": "products-33612c4d-confined0-WXUgJq",
  "xwide12": "products-33612c4d-xwide12-WXUgJq",
  "xwideOffset11": "products-33612c4d-xwideOffset11-WXUgJq",
  "wide6": "products-33612c4d-wide6-WXUgJq",
  "xwideOffset7": "products-33612c4d-xwideOffset7-WXUgJq",
  "wide8": "products-33612c4d-wide8-WXUgJq",
  "wide1": "products-33612c4d-wide1-WXUgJq",
  "defaultOffset11": "products-33612c4d-defaultOffset11-WXUgJq",
  "wideOffset1": "products-33612c4d-wideOffset1-WXUgJq",
  "defaultOffset9": "products-33612c4d-defaultOffset9-WXUgJq",
  "confinedOffset11": "products-33612c4d-confinedOffset11-WXUgJq",
  "confined4": "products-33612c4d-confined4-WXUgJq",
  "xwide6": "products-33612c4d-xwide6-WXUgJq",
  "default8": "products-33612c4d-default8-WXUgJq",
  "tinyOffset4": "products-33612c4d-tinyOffset4-WXUgJq",
  "xwide0": "products-33612c4d-xwide0-WXUgJq",
  "xwideOffset8": "products-33612c4d-xwideOffset8-WXUgJq",
  "defaultOffset7": "products-33612c4d-defaultOffset7-WXUgJq",
  "xwideOffset0": "products-33612c4d-xwideOffset0-WXUgJq",
  "xwideOffset10": "products-33612c4d-xwideOffset10-WXUgJq",
  "wideOffset2": "products-33612c4d-wideOffset2-WXUgJq",
  "wideOffset6": "products-33612c4d-wideOffset6-WXUgJq",
  "confinedOffset4": "products-33612c4d-confinedOffset4-WXUgJq",
  "wide9": "products-33612c4d-wide9-WXUgJq",
  "confined5": "products-33612c4d-confined5-WXUgJq",
  "xwideOffset4": "products-33612c4d-xwideOffset4-WXUgJq",
  "confined7": "products-33612c4d-confined7-WXUgJq",
  "default11": "products-33612c4d-default11-WXUgJq",
  "tinyOffset6": "products-33612c4d-tinyOffset6-WXUgJq",
  "xwide1": "products-33612c4d-xwide1-WXUgJq",
  "default7": "products-33612c4d-default7-WXUgJq",
  "default1": "products-33612c4d-default1-WXUgJq",
  "defaultOffset3": "products-33612c4d-defaultOffset3-WXUgJq",
  "tiny12": "products-33612c4d-tiny12-WXUgJq",
  "wide11": "products-33612c4d-wide11-WXUgJq",
  "tiny9": "products-33612c4d-tiny9-WXUgJq",
  "col": "products-33612c4d-col-WXUgJq",
  "wide7": "products-33612c4d-wide7-WXUgJq",
  "wideOffset4": "products-33612c4d-wideOffset4-WXUgJq",
  "xwide11": "products-33612c4d-xwide11-WXUgJq",
  "tinyOffset11": "products-33612c4d-tinyOffset11-WXUgJq",
  "xwide5": "products-33612c4d-xwide5-WXUgJq",
  "tiny11": "products-33612c4d-tiny11-WXUgJq",
  "tinyOffset3": "products-33612c4d-tinyOffset3-WXUgJq",
  "tiny2": "products-33612c4d-tiny2-WXUgJq",
  "wide12": "products-33612c4d-wide12-WXUgJq",
  "defaultOffset1": "products-33612c4d-defaultOffset1-WXUgJq",
  "default10": "products-33612c4d-default10-WXUgJq",
  "confined8": "products-33612c4d-confined8-WXUgJq",
  "confinedOffset5": "products-33612c4d-confinedOffset5-WXUgJq",
  "wideOffset0": "products-33612c4d-wideOffset0-WXUgJq",
  "wideOffset8": "products-33612c4d-wideOffset8-WXUgJq",
  "xwideOffset9": "products-33612c4d-xwideOffset9-WXUgJq",
  "tinyOffset1": "products-33612c4d-tinyOffset1-WXUgJq",
  "standardGridContainer": "products-33612c4d-standardGridContainer-WXUgJq",
  "default9": "products-33612c4d-default9-WXUgJq",
  "defaultOffset4": "products-33612c4d-defaultOffset4-WXUgJq",
  "default5": "products-33612c4d-default5-WXUgJq",
  "confinedOffset9": "products-33612c4d-confinedOffset9-WXUgJq",
  "tiny10": "products-33612c4d-tiny10-WXUgJq",
  "confinedOffset1": "products-33612c4d-confinedOffset1-WXUgJq",
  "wideOffset7": "products-33612c4d-wideOffset7-WXUgJq",
  "defaultOffset5": "products-33612c4d-defaultOffset5-WXUgJq",
  "confined10": "products-33612c4d-confined10-WXUgJq",
  "confined11": "products-33612c4d-confined11-WXUgJq",
  "confinedOffset10": "products-33612c4d-confinedOffset10-WXUgJq",
  "wideOffset5": "products-33612c4d-wideOffset5-WXUgJq",
  "wideOffset9": "products-33612c4d-wideOffset9-WXUgJq",
  "confinedOffset8": "products-33612c4d-confinedOffset8-WXUgJq",
  "xwideOffset3": "products-33612c4d-xwideOffset3-WXUgJq",
  "defaultOffset6": "products-33612c4d-defaultOffset6-WXUgJq",
  "row": "products-33612c4d-row-WXUgJq",
  "wide2": "products-33612c4d-wide2-WXUgJq",
  "default2": "products-33612c4d-default2-WXUgJq",
  "tiny6": "products-33612c4d-tiny6-WXUgJq",
  "defaultOffset10": "products-33612c4d-defaultOffset10-WXUgJq",
  "xwide2": "products-33612c4d-xwide2-WXUgJq",
  "tinyOffset5": "products-33612c4d-tinyOffset5-WXUgJq",
  "xwideOffset5": "products-33612c4d-xwideOffset5-WXUgJq"
};